import { render } from "./TheStopLoss.vue?vue&type=template&id=c4f797a6&scoped=true&ts=true"
import script from "./TheStopLoss.vue?vue&type=script&lang=ts"
export * from "./TheStopLoss.vue?vue&type=script&lang=ts"

import "./TheStopLoss.vue?vue&type=style&index=0&id=c4f797a6&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f797a6"]])

export default __exports__